
import { useState } from "react";
import "./FreeCareerCounselling.css";
import InquiryFormModal from "../../common_components/InquiryFormModal/InquiryFormModal";

const FreeCareerCounselling = () => {
  const [modalshow, setmodalshow] = useState(false);
  const openModal = () => {
    setmodalshow(true);
    // setExpanded(false);
  };
  return (
    <section className="free_career_section">
      <div className="container">
        <div className="career_content">
          <h2>Confused to choose? Get a free career counselling</h2>

          <button className="consultation_btn" onClick={openModal}>
            Get Free Consultation
          </button>
        </div>
      </div>

      <InquiryFormModal
        show={modalshow}
        onHide={() => {
          setmodalshow(false);
          // setExpanded(false);
        }}
        setmodalshow={setmodalshow}
        modalshow={modalshow}
      />
    </section>
  );
};

export default FreeCareerCounselling;
